var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-5 p-st",class:{ 'bg-white': !_vm.nightMode, 'bg-dark': _vm.nightMode }},[_c('div',{staticClass:"gif-container"},[_c('img',{staticClass:"centered-gif",attrs:{"src":_vm.gifPath,"alt":"Local GIF"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }